// extracted by mini-css-extract-plugin
module.exports = {"container":"TermTagsUpdate_container__3xoQ3","section":"TermTagsUpdate_section__3VCVs"};